import type { JSX } from 'react'

export function GettingStartedDownloadPlatformIcon(): JSX.Element {
  return (
    <svg
      width='592'
      height='344'
      viewBox='0 0 592 344'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g transform='translate(213, 105)'>
        <svg
          width='166'
          height='134'
          viewBox='0 0 166 134'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M125.988 79.8423C125.988 79.0139 126.66 78.3423 127.488 78.3423C128.316 78.3424 128.988 79.0139 128.988 79.8423V101.934C128.988 102.762 128.316 103.434 127.488 103.434H120.867L126.51 110.841H126.511L132.821 119.099L139.134 110.841L144.777 103.434H138.134C137.305 103.434 136.634 102.762 136.634 101.934V79.8423C136.634 79.014 137.305 78.3425 138.134 78.3423C138.962 78.3423 139.634 79.0139 139.634 79.8423V100.434H147.806C148.377 100.434 148.897 100.757 149.15 101.268C149.403 101.779 149.345 102.39 149 102.843L141.518 112.662L141.517 112.664L134.013 122.482C133.73 122.853 133.289 123.071 132.822 123.071C132.355 123.071 131.913 122.853 131.63 122.482L124.127 112.664L124.126 112.662L116.644 102.843C116.299 102.39 116.241 101.779 116.494 101.268C116.747 100.757 117.268 100.434 117.838 100.434H125.988V79.8423Z'
            fill='#161616'
          />
          <path
            d='M1.33301 99.1445V15.6875C1.33301 7.68207 7.77298 1.20042 15.7363 1.2002H54.6025C55.0207 1.2002 55.4202 1.37469 55.7041 1.68164L73.4971 20.9268H126.426C134.568 20.9269 141.161 27.566 141.161 35.7705V58.5537C141.161 59.3821 140.49 60.0537 139.661 60.0537C138.833 60.0536 138.161 59.3821 138.161 58.5537V35.7705C138.161 29.203 132.891 23.9269 126.426 23.9268H72.8408C72.4226 23.9268 72.0232 23.7514 71.7393 23.4443L53.9473 4.2002H15.7363C9.44619 4.20042 4.33301 9.32252 4.33301 15.6875V99.1445C4.33302 106.761 10.4445 112.886 17.9502 112.886H92.7168L92.8701 112.894C93.6264 112.971 94.2168 113.609 94.2168 114.386C94.2167 115.162 93.6263 115.801 92.8701 115.878L92.7168 115.886H17.9502C8.76742 115.886 1.33302 108.398 1.33301 99.1445Z'
            fill='#161616'
          />
          <path
            d='M161.688 100.707C161.688 84.6153 148.753 71.591 132.822 71.5908C116.891 71.5908 103.955 84.6152 103.955 100.707C103.955 116.799 116.891 129.822 132.822 129.822C148.753 129.822 161.688 116.799 161.688 100.707ZM164.688 100.707C164.688 118.432 150.433 132.822 132.822 132.822C115.211 132.822 100.955 118.432 100.955 100.707C100.955 82.9815 115.211 68.5908 132.822 68.5908C150.433 68.591 164.688 82.9816 164.688 100.707Z'
            fill='#161616'
          />
          <path
            d='M61.8865 80.3508H51.5773C50.3256 80.3508 49.1687 79.6787 48.5447 78.588L42.6219 68.261C41.9979 67.1703 41.9979 65.8261 42.6219 64.7354L48.5447 54.4084C49.1687 53.3177 50.3256 52.6456 51.5773 52.6456H61.8829L70.0682 38.378C69.893 38.3633 69.7215 38.3413 69.5427 38.3413H45.4611C42.9175 38.3413 40.5674 39.7075 39.2938 41.9256L27.2511 62.9139C25.9775 65.132 25.9775 67.8607 27.2511 70.0789L39.2938 91.0671C40.5674 93.2852 42.9175 94.6514 45.4611 94.6514H69.5427C69.7215 94.6514 69.8967 94.6294 70.0719 94.6147L61.8865 80.3471V80.3508Z'
            fill='#FF0044'
          />
          <path
            d='M87.7526 62.9174L75.7099 41.9292C75.6187 41.775 75.5129 41.6318 75.4144 41.4849L67.229 55.7524L72.3854 64.739C73.0095 65.8297 73.0095 67.1738 72.3854 68.2646L67.2327 77.2474L75.418 91.515C75.5165 91.3681 75.6224 91.2286 75.7099 91.0743L87.7526 70.0861C89.0262 67.8679 89.0262 65.1393 87.7526 62.9211V62.9174Z'
            fill='#28F981'
          />
        </svg>
      </g>
    </svg>
  )
}
